import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import SeoSrpCardUi from '@stencil/dstories/src/components/SRP/SrpCard/srp-card-ui';
import {
  commonFareRulesDataSelector,
  postSearchRkeysDataSelector,
  messageValuesSelector
} from '@stencil/flights-seo-reducers/src/SRP/redux/selectors';
import { getBaggageDataAndFareRulesSRP } from '@stencil/flights-seo-reducers/src/SRP/redux/thunks';
import { getCouponPersuationDetails } from '@stencil/flights-utils/src/srp-thor-utils';

const SeoSrpCard = props => {
  const dispatch = useDispatch();

  const commonRulesData = useSelector(commonFareRulesDataSelector);
  const postSearchRkeysData = useSelector(postSearchRkeysDataSelector);
  const messageValues = useSelector(messageValuesSelector);

  const { flightItem, handleFlightSelection, isFlightSelected, airports } = props;

  const offerInfo = getCouponPersuationDetails({
    rKeys: postSearchRkeysData,
    messageValues,
    id: flightItem?.fareKey
  });

  const callCommonRulesAPI = () => {
    dispatch(getBaggageDataAndFareRulesSRP(flightItem));
  };

  return (
    <SeoSrpCardUi
      isFlightSelected={isFlightSelected}
      handleFlightSelection={handleFlightSelection}
      flightItem={flightItem}
      airports={airports}
      commonRulesData={commonRulesData[flightItem.id]}
      callCommonRulesAPI={callCommonRulesAPI}
      offerInfo={offerInfo}
    />
  );
};

export default SeoSrpCard;
